import { styled } from "@mui/material/styles";
import { ReactNode } from "react";
import { useInView } from "react-intersection-observer";

import { FadeUpAnimationWrapper } from "../../../components/FadeUpAnimationWrapper";
import { MarketPlaceSection } from "../../../components/MarketPlace/MarketPlaceSection";

export type ProductSectionWrapperProps = {
    id: string;
    children: ReactNode;
    onVisibilityChange: (id: string, inView: boolean) => void;
    withSectionFadeUpAnimation: boolean;
    withBottomBorder?: boolean;
    ContainerComponent?: React.ComponentType;
    scrollMarginTop: number;
};
export const ProductSectionWrapper = ({
    children,
    withSectionFadeUpAnimation,
    withBottomBorder,
    id,
    onVisibilityChange,
    ContainerComponent,
    scrollMarginTop,
    ...props
}: ProductSectionWrapperProps) => {
    const { ref } = useInView({
        threshold: 0.5,
        rootMargin: "0px -10000px 0px -10000px",
        onChange: (inView) => onVisibilityChange(id, inView),
    });

    const Wrapper = ContainerComponent ?? "div";

    return (
        <Wrapper ref={ref} id={id} {...props} style={{ scrollMarginTop }}>
            <FadeUpAnimationWrapper isEnabled={withSectionFadeUpAnimation}>
                <ProductSectionWrapperContainer data-with-bottom-border={withBottomBorder}>
                    {children}
                </ProductSectionWrapperContainer>
            </FadeUpAnimationWrapper>
        </Wrapper>
    );
};

const ProductSectionWrapperContainer = styled(MarketPlaceSection)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.airiness,
    "&[data-with-bottom-border=true]": {
        borderBottom: "solid 1px",
        borderColor: theme.palette.grey[300],
    },
}));
